import { Table } from 'antd';
import { FC } from 'react';
import styles from './index.module.scss';
import { EllipsisSpan } from '@maxtropy/components';
import { DatabaseOutlined } from '@ant-design/icons';
import { PhotovoltaicMeterGroupsItem, PhotovoltaicQuantitiesItem } from '../../../../api/electricity';
import { units } from '../utils';
import {
  HasTimeOfUseElectricityPricePropsType,
  HasTimeOfUseElectricityPriceProps,
} from '../../../../api/electricitySettlementRules';

const columns = [
  {
    title: '',
    dataIndex: 'highLowType',
    ellipsis: { showTitle: true },
    render: (v: HasTimeOfUseElectricityPricePropsType) => (
      <EllipsisSpan value={v in HasTimeOfUseElectricityPricePropsType ? HasTimeOfUseElectricityPriceProps[v] : '总'} />
    ),
    width: 70,
    // className: `${styles.firstCell}`,
  },
  {
    title: '反向电本月示数',
    dataIndex: 'currentQuantity',
    ellipsis: { showTitle: true },
    render: (v: number) => <EllipsisSpan value={v?.toFixed(2)} />,
  },
  {
    title: '反向电上月示数',
    dataIndex: 'lastQuantity',
    ellipsis: { showTitle: true },
    render: (v: number) => <EllipsisSpan value={v?.toFixed(2)} />,
  },
  {
    title: '倍率',
    dataIndex: 'multiplyRatio',
    ellipsis: { showTitle: true },
    render: (v: number) => <EllipsisSpan value={v} />,
  },
  {
    title: '反向上网电量',
    dataIndex: 'totalActivePowerQuantity',
    ellipsis: { showTitle: true },
    render: (v: number) => (
      <EllipsisSpan value={v !== undefined && v !== null ? `${v?.toFixed(2)} ${units.千瓦时}` : v} />
    ),
  },
];

const ResidualElectricityPower: FC<{ demandMeterGroups: PhotovoltaicMeterGroupsItem[] }> = ({ demandMeterGroups }) => {
  const activePowerTables = demandMeterGroups.map(i => {
    const dataSource = i.quantities.map(item => {
      return {
        id: item.id,
        lastQuantity: item.lastQuantity,
        currentQuantity: item.currentQuantity,
        multiplyRatio: item.multiplyRatio,
        totalActivePowerQuantity: item.totalActivePowerQuantity,
        highLowType: item.highLowType,
      };
    });

    const tableDataSource = [
      ...dataSource,
      ...[
        dataSource.reduce(
          (a, b) => {
            return {
              ...a,
              lastQuantity: (a.lastQuantity ?? 0) + (b.lastQuantity ?? 0),
              currentQuantity: (a.currentQuantity ?? 0) + (b.currentQuantity ?? 0),
              totalActivePowerQuantity: (a.totalActivePowerQuantity ?? 0) + (b.totalActivePowerQuantity ?? 0),
              multiplyRatio: b.multiplyRatio ?? a.multiplyRatio,
            };
          },
          {
            id: '总',
            highLowType: 5,
            lastQuantity: 0,
            currentQuantity: 0,
            totalActivePowerQuantity: 0,
            multiplyRatio: undefined,
          } as unknown as Partial<PhotovoltaicQuantitiesItem>
        ),
      ],
    ];

    return (
      <div key={i.meterId}>
        <div>
          <DatabaseOutlined style={{ color: 'var(--primary-color)', fontSize: 18 }} />
          设备名称：{i.deviceName}
        </div>
        <div className={styles.activePowerTable}>
          <Table rowKey="highLowType" pagination={false} dataSource={tableDataSource} columns={columns} />
        </div>
      </div>
    );
  });

  return <>{activePowerTables}</>;
};

export default ResidualElectricityPower;
